import { Phone, Mail, ExternalLink, Clock3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL } from "@/lib/api";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-white border-t border-slate-200 py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="text-[11px] uppercase tracking-[0.22em] text-brand-teal flex items-center gap-2 mb-5">
            <span className="h-px w-8 bg-brand-gold" /> Contact
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.08]">
            Get in touch today.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed max-w-md">
            Reach a real person, anytime. For service requests, our booking
            site is the fastest way to get scheduled.
          </p>

          <div
            className="mt-8 inline-flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-900 px-4 py-2 rounded-sm text-sm font-medium"
            data-testid="contact-dispatch-badge"
          >
            <Clock3 className="h-4 w-4" /> Available by appointment &amp; availability · NJ · PA · NY
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
          {/* Phone */}
          <a
            href="tel:5169198679"
            data-testid="contact-phone-card"
            className="group bg-white p-8 md:p-10 flex flex-col gap-3 hover:bg-slate-50 transition-colors"
          >
            <span className="inline-flex h-11 w-11 items-center justify-center bg-brand-teal text-white rounded-sm group-hover:bg-brand-teal-hover transition-colors">
              <Phone className="h-5 w-5" />
            </span>
            <div className="text-[11px] uppercase tracking-widest text-slate-500">
              Call us
            </div>
            <div className="font-heading text-2xl md:text-3xl font-semibold text-slate-900 tracking-tight">
              516-919-8679
            </div>
            <div className="text-xs text-slate-500">
              Tap to call · by appointment &amp; availability
            </div>
          </a>

          {/* Email */}
          <a
            href="mailto:tj.clinicalsolutions@gmail.com"
            data-testid="contact-email-card"
            className="group bg-white p-8 md:p-10 flex flex-col gap-3 hover:bg-slate-50 transition-colors"
          >
            <span className="inline-flex h-11 w-11 items-center justify-center bg-slate-900 text-white rounded-sm group-hover:bg-brand-teal transition-colors">
              <Mail className="h-5 w-5" />
            </span>
            <div className="text-[11px] uppercase tracking-widest text-slate-500">
              Email us
            </div>
            <div className="font-heading text-lg md:text-xl font-semibold text-slate-900 break-all">
              tj.clinicalsolutions@gmail.com
            </div>
            <div className="text-xs text-slate-500">
              We respond within one business day
            </div>
          </a>

          {/* Book Service */}
          <div className="sm:col-span-2 bg-brand-navy text-white p-8 md:p-10 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between">
            <div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-amber-300 mb-2">
                Need a service?
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold tracking-tight">
                Book on our service portal — fastest way to schedule.
              </h3>
            </div>
            <Button
              asChild
              data-testid="contact-book-service-button"
              size="lg"
              className="bg-brand-teal hover:bg-brand-teal-hover text-white rounded-sm h-12 px-6 font-semibold tracking-wide whitespace-nowrap"
            >
              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Book a Service <ExternalLink className="h-4 w-4 ml-2" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
